module.exports = __webpack_public_path__ + "static/img/14000076.25c1f3c0.png";